import React, { useMemo } from 'react';
import styles from './ProgressBar.module.scss';
import compose from '../utils/compose';
import normalizeLocaleData from '../utils/i18n/normalizeLocaleData';
import { withAdditionalIntl } from '../I18n/AdditionalIntl/AdditionalIntl';
import { injectIntl } from 'react-intl';
import en from './locales/ProgressBar.en.json';
import I18n, { formatI18n } from '../I18n/I18n/I18n';
var messages = normalizeLocaleData(en, '@dm/components.progress-bar');
export function ProgressBar(_ref) {
  var _ref$show = _ref.show,
    show = _ref$show === void 0 ? true : _ref$show,
    progress = _ref.progress,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    width = _ref.width,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? '@dm/components.progress-bar.default-name' : _ref$name,
    intl = _ref.intl;
  var formattedName = formatI18n(intl, name);
  var style = useMemo(function () {
    return width ? {
      width: width
    } : undefined;
  }, [width]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, show && /*#__PURE__*/React.createElement("progress", {
    className: styles.bar,
    max: max,
    value: progress,
    style: style,
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": progress
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.fallback
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.fallbackbar,
    style: {
      width: "".concat(progress, "%")
    },
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": progress
  }))), /*#__PURE__*/React.createElement("span", {
    "aria-live": "polite",
    "aria-relevant": "additions text",
    className: "assistive-text"
  }, !!progress && /*#__PURE__*/React.createElement(React.Fragment, null, progress < 100 ? /*#__PURE__*/React.createElement(React.Fragment, null, formattedName, /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.progress-bar.progress"
  })) : /*#__PURE__*/React.createElement("span", {
    "aria-atomic": true
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: {
      id: '@dm/components.progress-bar.complete',
      values: {
        formattedName: formattedName
      }
    }
  })), progress < 100 && "".concat(progress, "%"))));
}
export default compose(withAdditionalIntl({
  messages: messages,
  path: 'ProgressBar/locales/ProgressBar',
  namespace: '@dm/components.progress-bar'
}), injectIntl)(ProgressBar);